// GraphQL operation documents for admin Group Trial management (SEN-6115).
// Exported from one module so components and tests reference identical documents.
// Verified against the merged Admin Service API docs:
//   - Mutations carry NO `Admin` prefix.
//   - The read query IS `Admin`-prefixed and takes an explicit organizationId.
//   - `assessmentQuotas` is a serialized JSON string; `created` is a
//     _Neo4jDateTime and must select { formatted }, like every other date field.
import { gql } from '@apollo/client';

const GROUP_TRIAL_FIELDS = `
  id
  name
  description
  status
  maxParticipants
  assessmentQuotas
  created {
    formatted
  }
`;

export const ADMIN_RETRIEVE_GROUP_TRIALS = gql`
  query AdminRetrieveGroupTrials($organizationId: ID!) {
    AdminRetrieveGroupTrials(organizationId: $organizationId) {
      ${GROUP_TRIAL_FIELDS}
    }
  }
`;

export const CREATE_GROUP_TRIAL = gql`
  mutation CreateGroupTrial($input: CreateGroupTrialInput!) {
    CreateGroupTrial(input: $input) {
      ${GROUP_TRIAL_FIELDS}
    }
  }
`;

export const UPDATE_GROUP_TRIAL = gql`
  mutation UpdateGroupTrial($input: UpdateGroupTrialInput!) {
    UpdateGroupTrial(input: $input) {
      ${GROUP_TRIAL_FIELDS}
    }
  }
`;

export const UPDATE_GROUP_TRIAL_STATUS = gql`
  mutation UpdateGroupTrialStatus($input: UpdateGroupTrialStatusInput!) {
    UpdateGroupTrialStatus(input: $input) {
      id
      status
    }
  }
`;
